<ion-content class="register-area">
  <app-register-header 
    [step]="step" 
    [selectedRole]="selectedRole"
    (backClicked)="backto($event)">
  </app-register-header>
  <div class="content-register">
    <div
      class="content-wrapper"
      [ngClass]="{'wrapper-8': step === 0}"
      *ngIf="step == 0"
    >
      <app-role-selector 
        [selectedRole]="selectedRole"
        (roleSelected)="handleRoleSelection($event)">
      </app-role-selector>
    </div>
    
    <app-register-footer 
      [step]="step"
      [buttonText]="'BUTTONS.CONTINUE'"
      (continueClicked)="nextSteps($event)">
    </app-register-footer>

    <div class="step" *ngIf="step === 1">
      <app-first-step
        [role]="selectedRole"
        (ValidForm)="updateForm(1, $event)"
        [f]="form"
        (goTo)="stepVal($event)"
      ></app-first-step>
    </div>
    <div class="step" *ngIf="step === 2 && selectedRole ==='prestataire'">
      <app-second-step
        [role]="selectedRole"
        (ValidForm)="updateForm(2, $event)"
        [f]="form"
        (goTo)="stepVal($event)"
      ></app-second-step>
    </div>
    <div *ngIf="step === 0">
      <app-version></app-version>
    </div>
  </div>
</ion-content>
